export const selectToken = (state) => state.artist.token;

export const selectArtist = (state) => state.artist;
export const selectMyEvent = (state) => state.artist.event;
